module.exports = __webpack_public_path__ + "static/media/ic-print.ff89d05f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-print.svg
// module id = 655
// module chunks = 14